import { MEMBER_ROLE_LABELS } from '../members/memberConstants';

export const VERIFY_CODE_PAGE_SIZE = 20;

export const VERIFY_CODE_ROLE_OPTIONS = [
  { value: '', label: '全部' },
  { value: '1', label: '正常帳號' },
  { value: '2', label: '試玩帳號' },
  { value: '3', label: '測試帳號' },
];

export const VERIFY_CODE_SCENE_LABELS = {
  REGISTER: '註冊',
  RESET_LOGIN_PASSWORD: '重置登入密碼',
  RESET_TRADE_PASSWORD: '重置交易密碼',
  DELETE_WITHDRAW_ADDRESS: '刪除出金地址',
};

export const VERIFY_CODE_TYPE_LABELS = {
  MOBILE: 'PHONE',
  EMAIL: 'EMAIL',
  FACEBOOK: 'FACEBOOK',
  GOOGLE: 'GOOGLE',
};

export function buildVerifyCodePageParams(pageNo, filters, pageSize = VERIFY_CODE_PAGE_SIZE) {
  const params = {
    pageNo,
    pageSize,
  };
  if (filters.roleId) {
    params.roleId = Number(filters.roleId);
  }
  if (filters.memberId?.trim()) {
    params.memberId = Number(filters.memberId.trim());
  }
  if (filters.verifySend?.trim()) {
    params.verifySend = filters.verifySend.trim();
  }
  return params;
}

export function formatVerifyCodeScene(value) {
  return VERIFY_CODE_SCENE_LABELS[value] || value || '—';
}

export function formatVerifyCodeType(value) {
  return VERIFY_CODE_TYPE_LABELS[value] || value || '—';
}

export function formatVerifyCodeRole(roleId) {
  if (roleId == null || roleId === '') {
    return '—';
  }
  return MEMBER_ROLE_LABELS[Number(roleId)] || String(roleId);
}

export function formatVerifyDevice(value) {
  if (!value) {
    return '—';
  }
  const ua = String(value).toUpperCase();
  if (ua.includes('IPHONE') || ua.includes('IPAD') || ua.includes('IOS')) {
    return 'IOS';
  }
  if (ua.includes('ANDROID')) {
    return 'ANDROID';
  }
  if (ua.includes('MOBILE')) {
    return 'MOBILE';
  }
  return 'PC';
}
